<template>
  <div>
    <!-- info empty insurance_status -->

    <div v-if="model.insurance_status===''|| !model.insurance_status" class="flex-gt-sm-100 flex-100  mb-4 mx-2 pa-3 report layout-row layout-align-start-center"
         :class="{'red darken-5 white--text': isDarkMode, 'red lighten-5 red--text text--darken-3': !isDarkMode}"
         style="border:1px solid;border-radius: 9px;"
         :style="{'border-color': compColor.isInDarkMode ? compColor.primeHighlightColor : 'transparent'}">
      <div class="layout-column layout-align-center-center mr-3">
        <v-icon size="30" :color="isDarkMode ? 'white' : 'red darken-3'">mdi-information</v-icon>
      </div>
      <span style="font-size: 14px;">{{ $t('COMPONENT_PATIENT.INFO_EMPTY_INSURANCE_STATUS') }}</span>
    </div>

    <!-- insurance_status==='legal' -->

    <div class="flex layout-row layout-wrap" v-if="model.insurance_status==='legal'">

      <!-- insurance_number -->

      <div class="flex-gt-sm-50 flex-100 px-2">
        <validation-provider tag="div"
                             :name="path + '.gkv.gkv_versichertennummer'"
                             rules="required|insurance_number"
                             v-slot="{ errors }">
          <v-text-field
            :dark="compColor.isInDarkMode"
            v-model="model.gkv.gkv_versichertennummer"
            :label="formatInsuranceNumberLabel()"
            :color="compColor.isInDarkMode ? compColor.primeHighlightColor : compColor.primeColor"
            :error-messages="errors[0]"
            :hide-details="!errors || errors.length <= 0"
            outlined
            :dense="denseFields">
          </v-text-field>
        </validation-provider>
      </div>

      <!-- insurance_company_number -->

      <div class="flex-gt-sm-50 flex-100 px-2">
        <validation-provider tag="div"
                             :name="path + '.gkv.iknr'"
                             rules="required|min:9|max:9|numeric|insurance_company_gkv"
                             v-slot="{ errors }">

          <lx-autocomplete
            :label="$t('COMPONENT_PATIENT.INSURANCE_COMPANY_NUMBER') + ' *'"
            v-model="model.gkv.iknr"
            :error="errors[0]"
            @search-method="getDataForAutocomplete"
            @input="setInsuranceCompany"
            :length="3"
            :dense="denseFields"
            :hide-details="!errors || errors.length <= 0"
            :results="resultSearchModel">
            <template v-slot="slotProps">
              <div class="layout-row">
                <div style="width: 120px;border-radius: 4px; word-wrap: normal;"
                     class="mr-2 px-2 white lighten-2 layout-column layout-align-center-start">
                  <h3>
                    <lx-text-highlight :text="slotProps.lineItem.ik.toString()"
                                       :search-string="slotProps.searchText"
                                       :color="compColor.prime"></lx-text-highlight>
                  </h3>
                </div>
                <div class="flex">
                <span class="body-2">
                  <lx-text-highlight :text="slotProps.lineItem.name" :search-string="slotProps.searchText"
                                     :color="compColor.prime"></lx-text-highlight>
                </span>
                </div>
              </div>
            </template>
          </lx-autocomplete>
        </validation-provider>
      </div>
    </div>

    <!-- insurance_status==='private' -->

    <div class="flex layout-row layout-wrap" v-if="model.insurance_status==='private'">

      <!-- info pkv -->

      <div class="flex-gt-sm-100 flex-100  mb-4 mx-2 pa-3 report layout-row layout-align-start-center"
           :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5 white--text ' : '']"
           style="border:1px solid;border-radius: 9px;"
           :style="{'border-color': compColor.isInDarkMode ? compColor.primeHighlightColor : 'transparent'}">
        <div class="layout-column layout-align-center-center mr-3">
          <v-icon size="30" :color="compColor.prime">mdi-information</v-icon>
        </div>
        <span style="font-size: 14px;" :class="compColor.primeClass">{{ $t('COMPONENT_PATIENT.INFO_INSURANCE_STATE_PRIVATE') }}</span>
      </div>

      <!-- insurance_number -->

      <div class="flex-gt-sm-50 flex-100 px-2">
        <validation-provider tag="div"
                             :name="path + '.pkv.pkv_versichertennummer'"
                             rules="trim_string"
                             v-slot="{ errors }">
          <v-text-field
            :dark="compColor.isInDarkMode"
            v-model="model.pkv.pkv_versichertennummer"
            :label="formatInsuranceNumberLabel()"
            :color="compColor.isInDarkMode ? compColor.primeHighlightColor : compColor.primeColor"
            :error-messages="errors[0]"
            maxLength="255"
            :hide-details="!errors || errors.length <= 0"
            outlined
            :dense="denseFields">
          </v-text-field>
        </validation-provider>
      </div>

      <!-- insurance_company_number -->

      <div class="flex-gt-sm-50 flex-100 px-2">
        <validation-provider tag="div"
                             :name="path + '.pkv.iknr'"
                             rules="required|numeric|insurance_company_pkv"
                             v-slot="{ errors }">

          <lx-autocomplete
            :label="$t('COMPONENT_PATIENT.INSURANCE_COMPANY_NUMBER_PKV') + ' *'"
            v-model="model.pkv.iknr"
            :error="errors[0]"
            @search-method="getDataForAutocomplete"
            @input="setInsuranceCompany"
            :length="2"
            :dense="denseFields"
            :hide-details="!errors || errors.length <= 0"
            :results="resultSearchModel">
            <template v-slot="slotProps">
              <div class="layout-row">
                <div style="width: 120px;border-radius: 4px; word-wrap: normal;"
                     class="mr-2 px-2 white lighten-2 layout-column layout-align-center-start">
                  <h3>
                    <lx-text-highlight :text="slotProps.lineItem.ik.toString()"
                                       :search-string="slotProps.searchText"
                                       :color="compColor.prime"></lx-text-highlight>
                  </h3>
                </div>
                <div class="flex">
                <span class="body-2">
                  <lx-text-highlight :text="slotProps.lineItem.name" :search-string="slotProps.searchText"
                                     :color="compColor.prime"></lx-text-highlight>
                </span>
                </div>
              </div>
            </template>
          </lx-autocomplete>
        </validation-provider>
      </div>

      <!-- beihilfetraeger -->

      <div class="flex-gt-sm-50 flex-100 px-2">
        <validation-provider tag="div"
                             :name="path + '.pkv.beihilfetraeger'"
                             rules="trim_string"
                             v-slot="{ errors }">
          <v-text-field
            :dark="compColor.isInDarkMode"
            v-model="model.pkv.beihilfetraeger"
            :label="$t('COMPONENT_PATIENT.INSURANCE_SUBSIDIARY')"
            :color="compColor.isInDarkMode ? compColor.primeHighlightColor : compColor.primeColor"
            :error-messages="errors[0]"
            maxLength="255"
            :hide-details="!errors || errors.length <= 0"
            outlined
            :dense="denseFields">
          </v-text-field>
        </validation-provider>
      </div>
    </div>

    <!-- insurance_status==='others' -->

    <div class="flex layout-row layout-wrap" v-if="model.insurance_status==='others'">

      <!-- info sonstige -->

      <div class="flex-gt-sm-100 flex-100  mb-4 mx-2 pa-3 report layout-row layout-align-start-center"
           :class="[!compColor.isInDarkMode ? compColor.prime + ' lighten-5 white--text ' : '']"
           style="border:1px solid;border-radius: 9px;"
           :style="{'border-color': compColor.isInDarkMode ? compColor.primeHighlightColor : 'transparent'}">
        <div class="layout-column layout-align-center-center mr-3">
          <v-icon size="30" :color="compColor.prime">mdi-information</v-icon>
        </div>
        <div class="layout-column">
          <span style="font-size: 14px;" :class="compColor.primeClass">{{ $t('COMPONENT_PATIENT.INFO_INSURANCE_STATE_OTHER') }}</span>
          <span class="mt-2" style="font-size: 14px;" :class="compColor.primeClass">Es muss entweder ein Ersatzcode oder eine Krankenkassennummer angegeben werden.</span>
        </div>

      </div>

      <!-- ersatzkode -->

      <div class="flex-gt-sm-50 flex-100 px-2">
        <validation-provider tag="div"
                             :name="path + '.sonstige.ersatzkode'"
                             :ref="path + '.sonstige.ersatzkode'"
                             :rules="{required: !model.sonstige.iknr && !model.sonstige.krankenkassen_name && !model.sonstige.versichertennummer}"
                             v-slot="{ errors }">
          <v-select
            :color="compColor.primeColor"
            :label="formatLabelOfIknrAndReplacementCode('COMPONENT_PATIENT.REPLACEMENT_CODE', 'replacement_code')"
            v-model="model.sonstige.ersatzkode"
            :items="ReplacementCodeTypes"
            :hide-details="!errors || errors.length <= 0"
            @change="resetReplacementCodeOrIKNR('iknr')"
            outlined
            :dense="denseFields"
            :error-messages="errors[0]"
            :menu-props="{ bottom: true, offsetY: true }"
            :dark="compColor.isInDarkMode">
            <template v-slot:item="{ item, on, attrs }">
              <v-list-item v-on="on"
                           :class="attrs.inputValue ? [compColor.prime, 'lighten-4'] : compColor.isInDarkMode?['blue-grey darken-4'] : []">
                <v-list-item-content class="py-0">
                  <label style="cursor:pointer;"
                         :class="attrs.inputValue ? [compColor.primeClass] : compColor.isInDarkMode ? ['white--text'] : []"
                         class="lighten-4 text--darken-2">{{ item.text }}</label>
                </v-list-item-content>
              </v-list-item>
            </template>
          </v-select>
        </validation-provider>
      </div>

      <div class="flex-gt-sm-50 flex-100 px-2"></div>

      <div class="flex-gt-sm-100 ml-3 mb-4" :class="compColor.primeClass">oder</div>

      <!-- insurance_company_number -->

      <div class="flex-gt-sm-50 flex-100 px-2">
        <validation-provider tag="div"
                             :name="path + '.sonstige.iknr'"
                             :rules="{numeric:true,insurance_company_sonstige:true,required: !model.sonstige.ersatzkode}"
                             v-slot="{ errors }">

          <lx-autocomplete
            :label="formatLabelOfIknrAndReplacementCode('COMPONENT_PATIENT.INSURANCE_COMPANY_NUMBER_OTHERS', 'iknr')"
            v-model="model.sonstige.iknr"
            :error="errors[0]"
            @search-method="getDataForAutocomplete"
            @input="setInsuranceCompany"
            :length="3"
            :dense="denseFields"
            :hide-details="!errors || errors.length <= 0"
            :results="resultSearchModel">
            <template v-slot="slotProps">
              <div class="layout-row">
                <div style="width: 120px;border-radius: 4px; word-wrap: normal;"
                     class="mr-2 px-2 white lighten-2 layout-column layout-align-center-start">
                  <h3>
                    <lx-text-highlight :text="slotProps.lineItem.ik.toString()"
                                       :search-string="slotProps.searchText"
                                       :color="compColor.prime"></lx-text-highlight>
                  </h3>
                </div>
                <div class="flex">
                <span class="body-2">
                  <lx-text-highlight :text="slotProps.lineItem.name" :search-string="slotProps.searchText"
                                     :color="compColor.prime"></lx-text-highlight>
                </span>
                </div>
              </div>
            </template>
          </lx-autocomplete>
        </validation-provider>
      </div>

      <!-- krankenkassen_name -->

      <div class="flex-gt-sm-50 flex-100 px-2">
        <validation-provider tag="div"
                             :name="path + '.sonstige.krankenkassen_name'"
                             rules="trim_string"
                             v-slot="{ errors }">
          <v-text-field
            :dark="compColor.isInDarkMode"
            v-model="model.sonstige.krankenkassen_name"
            :label="$t('COMPONENT_PATIENT.INSURANCE_COMPANY_NAME_OTHERS')"
            :color="compColor.isInDarkMode ? compColor.primeHighlightColor : compColor.primeColor"
            :error-messages="errors[0]"
            maxLength="255"
            @input="resetReplacementCodeOrIKNR()"
            :hide-details="!errors || errors.length <= 0"
            outlined
            :dense="denseFields">
          </v-text-field>
        </validation-provider>
      </div>

      <!-- insurance_number -->

      <div class="flex-gt-sm-50 flex-100 px-2">
        <validation-provider tag="div"
                             :name="path + '.sonstige.versichertennummer'"
                             rules="trim_string"
                             v-slot="{ errors }">
          <v-text-field
            :dark="compColor.isInDarkMode"
            v-model="model.sonstige.versichertennummer"
            :label="formatInsuranceNumberLabel()"
            :color="compColor.isInDarkMode ? compColor.primeHighlightColor : compColor.primeColor"
            :error-messages="errors[0]"
            maxLength="255"
            @input="resetReplacementCodeOrIKNR()"
            :hide-details="!errors || errors.length <= 0"
            outlined
            :dense="denseFields">
          </v-text-field>
        </validation-provider>
      </div>
    </div>
  </div>
</template>

<script>
import LxAutocomplete from '../../components/lx_auto_complete/LxAutocomplete'
import utils from '../../common/utils'
import metaData from '../../components/documentation/shared/formsMetaData'

export default {
  name: 'InsuranceData',
  mixins: [utils,metaData],
  components: {
    LxAutocomplete
  },
  props: {
    value: {
      type: Object,
      default: () => ({})
    },
    path: {
      type: String
    }
  },
  data () {
    return {
      model: {},
      kindOfInsurance: {
        legal: 'gkv',
        private: 'pkv',
        others: 'sonstige'
      },
      selectedKindOfInsurance: null,
      resultSearchModel: {},
      ReplacementCodeTypes: null
    }
  },
  created () {
    this.ReplacementCodeTypes = this.formsMetaData.ReplacementCodeTypes
  },
  methods: {
    /**
     * Delete iknr or ersatzcode in dependency to filled element
     *
     * @param valueToReset
     */
    resetReplacementCodeOrIKNR (valueToReset) {
      if (this.selectedKindOfInsurance === 'sonstige') {
        if (valueToReset === 'iknr') {
          this.$delete(this.model.sonstige, 'iknr')
          this.$delete(this.model.sonstige, 'krankenkassen_name')
          this.$delete(this.model.sonstige, 'versichertennummer')
        } else {
          this.$delete(this.model.sonstige, 'ersatzkode')
        }
      }
    },

    formatLabelOfIknrAndReplacementCode (text, value) {
      let label = this.$t(text)

      // if no element is selected, set * on iknr and ersatzkode
      if (!this.model.sonstige.iknr && !this.model.sonstige.ersatzkode && !this.model.sonstige.krankenkassen_name && !this.model.sonstige.versichertennummer) {
        label += ' *'
      }
      // if krankenkassen_name and/or versichertennummer is filled, set * on iknr
      else if (value === 'iknr' && (this.model.sonstige.krankenkassen_name || this.model.sonstige.versichertennummer)) {
        label += ' *'
      }

      return label
    },

    /**
     * Return label of insurance number in dependency to insurance state
     *
     * @returns {VueI18n.TranslateResult}
     */
    formatInsuranceNumberLabel () {
      let label = this.$t('COMPONENT_PATIENT.INSURANCE_NUMBER')

      if (!this.model.insurance_status || this.model.insurance_status === 'legal') {
        label += ' *'
      }

      return label
    },

    /**
     * Get list of insurance companies via regex in auto-complete
     *
     * @param data THe search string
     */
    getDataForAutocomplete (data) {
      // clear string from special characters to provide errors
      data = this.clearStringForRegexSearch(data)
      // reset resultModel to display the correct results after db-request
      this.resultSearchModel = {}

      this.$http.get('/ik/' + data + '/' + this.model.insurance_status)
        .then(res => {
          this.resultSearchModel = {
            result: res.data.items,
            count: res.data.count
          }
        })
        .catch(this.NotifyError)
    },

    /**
     * Set insurance company value via list form auto complete
     *
     * @param data The selected ops from list
     */
    setInsuranceCompany (data) {
      if (data && data.ik) {
        this.$set(this.model[this.selectedKindOfInsurance], 'iknr', data.ik.toString())
      }

      // todo im Zuge von Ticket #4012 auskommentiert
      // set insurance state of patient to private, when selected insurance has element insurance_type
      // if (data && data.insurance_type && data.insurance_type === 'private') {
      //   this.$set(this.model, 'insurance_status', 'private')
      // }

      if (this.selectedKindOfInsurance === 'sonstige') {
        this.resetReplacementCodeOrIKNR('replacementCode')
      }
    }
  },
  watch: {
    model: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.$emit('input', newValue)
        }
      },
      immediate: true
    },
    value: {
      handler: function (newValue, oldValue) {
        if (newValue !== oldValue) {
          this.model = newValue
        }
      },
      immediate: true
    },
    'model.insurance_status': {
      handler: function (newValue, oldValue) {
        if (newValue && newValue !== oldValue) {
          this.selectedKindOfInsurance = this.kindOfInsurance[newValue]
        }
      },
      immediate: true
    }
  }
}
</script>
